export default {
  PUBLISHED: "published",
  UNPUBLISHED: "published"
};
